import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const key = 'token'
const store = new Vuex.Store({
    state() {
        return {
            token:sessionStorage.getItem('token') || ''
        }
    },
    mutations: {
        $_setStorage(state, value) {
            state.token = value;
            sessionStorage.setItem(key, value)
        },
        $_removeStorage(state) {
            state.token = null;
            sessionStorage.removeItem(key)
        }
    }
})

export default store